import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import ChangePassword from "layouts/authentication/change-password";
import ResetPassword from "layouts/authentication/reset-password";
import SetNewPassword from "layouts/authentication/set-new-password";
import Shop from "./custom/Icons/Shop";
import Document from "./custom/Icons/Document";
import Profile from "./layouts/profile";
import Users from "./layouts/users";
import Branches from "./layouts/branches";
import BranchDetails from "./layouts/branches/components/BranchDetails";
import {
    AdminPanelSettings,
    Apartment,
    Business,
    ChildCare,
    LiveTv,
    ManageAccounts,
    NaturePeople,
    Notifications as NotificationsIcon,
    NotificationsActive as NotificationsActiveIcon,
    Person,
    Shield,
    SupervisorAccount,
    VideoCall,
    Work
} from "@mui/icons-material";
import Notifications from "./layouts/notifications";
import NotificationsDemo from "./layouts/notificationsDemo";
import Guardians from "./layouts/guardians";
import LiveStream from "./layouts/liveStream";
import KidMJPEGStreaming from "./layouts/faceDetection/KidMJPEGStreaming";
import GuardianDetailWrapper from "./layouts/guardians/components/GuardianDetailWrapper";
import ChildDetail from "./layouts/children/components/ChildDetail";
import Children from "./layouts/children";
import Admin from "./layouts/admin";
import AdminDetailPage from "./layouts/admin/components/AdminDetail";
import Staff from "./layouts/staff";
import StaffDetailPage from "./layouts/staff/components/StaffDetail";
import Branchadmin from "./layouts/branchadmin";
import BranchAdminDetailPage from "./layouts/branchadmin/components/BranchAdminDetail";
import Companyadmin from "./layouts/companyadmin";
import CompanyAdminDetailPage from "./layouts/companyadmin/components/CompanyAdminDetail";
import Companies from "./layouts/company";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
    roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN", "STAFF", "GUARDIAN"],
    showInSidenav: true
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
    showInSidenav: false
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    route: "/authentication/reset-password",
    icon: <Document size="12px" />,
    component: <ResetPassword />,
    noCollapse: true,
    showInSidenav: false
  },
  {
    type: "collapse",
    name: "Set New Password",
    key: "set-new-password",
    route: "/authentication/set-new-password",
    icon: <Document size="12px" />,
    component: <SetNewPassword />,
    noCollapse: true,
    showInSidenav: false
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    route: "/authentication/reset-password",
    icon: <Document size="12px" />,
    component: <ResetPassword />,
    noCollapse: true,
    showInSidenav: false
  },
    {
        type: "collapse",
        name: "Change Password",
        key: "change-password",
        route: "/change-password",
        icon: <Document size="12px"/>,
        component: <ChangePassword/>,
        noCollapse: true,
        showInSidenav: false
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <NaturePeople size="12px"/>,
    component: <Profile/>,
    noCollapse: true,
    roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN", "STAFF", "GUARDIAN"],
    showInSidenav: false
  },
  {
    type: "collapse",
    name: "Companies",
    key: "companies",
    route: "/companies",
    icon: <Business size="12px"/>,
    component: <Companies/>,
    noCollapse: true,
    roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN"],
    showInSidenav: true,
  },
  {
    type: "collapse",
    name: "Branches",
    key: "branches",
    route: "/branches",
    icon: <Apartment size="12px"/>,
    component: <Branches/>,
    noCollapse: true,
      roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN"],
    showInSidenav: true,
    children: [
      {
        type: "route",
        name: "Branch Details",
        key: "branch-details",
        route: ":branchId",
        component: <BranchDetails/>,
        noCollapse: true,
          roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN"],
      }
    ]
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <Person size="12px"/>,
    component: <Users/>,
    noCollapse: true,
      roles: ["SYSTEM_ADMIN", "ADMIN"],
    showInSidenav: true,
    children: [
      {
        type: "route",
        name: "User Details",
        key: "user-details",
        route: ":userId",
          component: <Profile/>,
          noCollapse: true,
          roles: ["SYSTEM_ADMIN", "ADMIN"],
      }
    ]
  },
    {
        type: "collapse",
        name: "Admins",
        key: "admins",
        route: "/admins",
        icon: <AdminPanelSettings size="12px"/>,
        component: <Admin/>,
        noCollapse: true,
        roles: ["SYSTEM_ADMIN"],
        showInSidenav: true,
        children: [
            {
                type: "route",
                name: "Admin Details",
                key: "admin-details",
                route: ":adminId",
                component: <AdminDetailPage/>,
                noCollapse: true,
                roles: ["SYSTEM_ADMIN"],
            }
        ]
    },
    {
        type: "collapse",
        name: "Company Admins",
        key: "company-admins",
        route: "/company-admins",
        icon: <SupervisorAccount size="12px"/>,
        component: <Companyadmin/>,
        noCollapse: true,
        roles: ["SYSTEM_ADMIN", "ADMIN"],
        showInSidenav: true,
        children: [
            {
                type: "route",
                name: "Company Admin Details",
                key: "company-admin-details",
                route: ":companyAdminId",
                component: <CompanyAdminDetailPage/>,
                noCollapse: true,
                roles: ["SYSTEM_ADMIN", "ADMIN"],
            }
        ]
    },
    {
      type: "collapse",
      name: "Branch Admins",
      key: "branch-admins",
      route: "/branch-admins",
      icon: <ManageAccounts size="12px"/>,
      component: <Branchadmin/>,
      noCollapse: true,
      roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN"],
      showInSidenav: true,
      children: [
          {
              type: "route",
              name: "Branch Admin Details",
              key: "branch-admin-details",
              route: ":branchAdminId",
              component: <BranchAdminDetailPage/>,
              noCollapse: true,
              roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN"],
          }
      ]
  },
        {
            type: "collapse",
            name: "Staff",
            key: "staff",
            route: "/staff",
            icon: <Work size="12px"/>,
            component: <Staff/>,
            noCollapse: true,
            roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN"],
            showInSidenav: true,
            children: [
                {
                    type: "route",
                    name: "Staff Details",
                    key: "staff-details",
                    route: ":staffId",
                    component: <StaffDetailPage/>,
                    noCollapse: true,
                    roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN"],
                }
            ]
      },
    {
      type: "collapse",
      name: "Guardians",
      key: "guardians",
      route: "/guardians",
      icon: <Shield size="12px"/>,
      component: <Guardians/>,
      noCollapse: true,
        roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN"],
      showInSidenav: true,
      children: [
        {
          type: "route",
          name: "Guardian Details",
          key: "guardian-details",
          route: ":guardianId",
            component: <GuardianDetailWrapper/>,
          noCollapse: true,
          roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN", "GUARDIAN"]
        },
      ]
    },
  {
    type: "collapse",
    name: "Children",
    key: "children",
    route: "/children",
    icon: <ChildCare size="12px"/>,
    component: <Children/>,
    noCollapse: true,
      roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN"],
    showInSidenav: true,
    children: [
      {
        type: "route",
        name: "Child Details",
        key: "child-details",
        route: ":childId",
          component: <ChildDetail/>,
        noCollapse: true,
          roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN", "GUARDIAN"]
      },
    ]
  },
  {
    type: "collapse",
    name: "LiveStream",
    key: "livestream",
    route: "/livestream",
    icon: <LiveTv size="12px"/>,
    component: <LiveStream/>,
    noCollapse: true,
      roles: ["SYSTEM_ADMIN", "ADMIN"],
    showInSidenav: true
  },
    {
        type: "collapse",
        name: "Monitor Your Kid",
        key: "monitor-your-kid",
        route: "/monitor-your-kid",
        icon: <VideoCall size="12px"/>,
        component: <KidMJPEGStreaming/>,
        noCollapse: true,
        roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN", "GUARDIAN"],
        showInSidenav: true
    },
    // Notifications inbox — every authenticated user has one. Reachable
    // from the bell in the navbar; hidden from the sidenav to keep it
    // uncluttered.
    {
        type: "collapse",
        name: "Notifications",
        key: "notifications",
        route: "/notifications",
        icon: <NotificationsIcon size="12px"/>,
        component: <Notifications/>,
        noCollapse: true,
        roles: ["SYSTEM_ADMIN", "ADMIN", "COMPANY_ADMIN", "BRANCH_ADMIN", "STAFF", "GUARDIAN"],
        showInSidenav: false
    },
    // System-admin-only demo page — compose + send a notification to
    // any user. Real flows will call the same backend service.
    {
        type: "collapse",
        name: "Send Notification",
        key: "notifications-demo",
        route: "/admin/notifications-demo",
        icon: <NotificationsActiveIcon size="12px"/>,
        component: <NotificationsDemo/>,
        noCollapse: true,
        roles: ["SYSTEM_ADMIN"],
        showInSidenav: true
    }
];

export default routes;
